module.exports = __webpack_public_path__ + "static/media/diet.72d58f23.png";